import styled from 'styled-components';

export const StyledWrapper = styled.div`
  width: 100%;
  display: flex;
  height: 212px !important;
  background: linear-gradient(270deg, #f5f6f7 0%, rgba(255, 255, 255, 0) 100%);
  padding: 24px !important;
  justify-content: space-between;
  img {
    height: 100%;
    width: 238.53px;
  }
`;
